var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 28,
    viewBox: "0 0 14 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1034 5.03701L13.4769 5.03866L13.4799 0.697864C13.0705 0.638428 11.6623 0.504359 10.0222 0.503218C6.6002 0.500838 4.25444 2.75947 4.25155 6.91372L4.24889 10.7369L0.472617 10.7343L0.469242 15.587L4.24551 15.5896L4.23702 27.7998L8.86691 27.8031L8.8754 15.594L12.4989 15.5965L13.0775 10.7442L8.87769 10.7413L8.88002 7.39811C8.88207 5.99554 9.24239 5.03572 11.1034 5.03701Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.368f4c5ec461c6348e7825bb155276b2.svg";
export { ForwardRef as ReactComponent };